<template>
  <div class="event-block-wrapper">
    <div class="activation-block" v-if="searchType == 0">
      <div class="info-card">
        <div class="info-left">
          <div class="info-icon">
            <i class="fas fa-key"></i>
          </div>
          <div class="info-header-text">
            <div class="info-title">
              <p>{{ $t("home.activate") }}</p>
            </div>
            <div class="info-info">
              <span>{{ $t("home.activateInfo1") }}</span>
              <span style="display:block; color:#ff6565;" v-if="getResponse.validationErrors.some(k => k.key == 'activationCode')"> {{ getResponse.validationErrors.find(k => k.key == "activationCode").value }} </span>
            </div>
          </div>
        </div>

        <div class="info-right">
          <div class="activation-bar">
            <the-mask placeholder="######-#######" :mask="['######-#######']" v-model="activationCode" v-if="$store.state.user != null" />
            <el-input v-mask="'######-#######'" placeholder="######-#######" v-model="activationCode" v-else :disabled="activateLoading">{{ $t("do_activate") }} </el-input>

            <el-button :disabled="activateLoading" class="md-primary md-raised" @click.stop="activateCode" type="primary" :loading="getLoading == 'activation'">{{ $t("do_activate") }}</el-button>
          </div>
        </div>
      </div>
      <div class="info-card" style="margin-top:10px" v-if="emailRequired || passwordRequired">
        <div class="info-left">
          <div style="display:flex; gap:10px;">
            <div class="custom-input email icon" :class="$inputError('email', response.validationErrors)" v-if="emailRequired || passwordRequired">
              <label>{{ $t("login.email.title") }}</label>
              <el-input placeholder="..." type="email" v-model="fastLogin.email" :class="$inputError('email', response.validationErrors)" :disabled="passwordRequired" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''"><i slot="prefix" class="fas fa-user"></i></el-input>
              <span class="md-error">{{ $errorMessage("email", response.validationErrors) }}</span>
            </div>

            <div class="custom-input password icon" :class="$inputError('password', response.validationErrors)" v-if="passwordRequired">
              <label>{{ $t("login.password.title") }}</label>
              <el-input :type="showpwd != true ? 'password' : 'text'" placeholder="..." v-model="fastLogin.password" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''">
                <i slot="prefix" class="fas fa-lock"></i>
                <i slot="suffix" class="fa show-pwd" :class="showpwd != true ? 'fa-eye' : 'fa-eye-slash'" @click="showpwd = !showpwd"></i>
              </el-input>
              <span class="md-error">{{ $errorMessage("password", response.validationErrors) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!close">
      <div class="event-block-title">
        <template v-if="searchType == 0 && events.length > 0">
          {{ $t("tabBar.events_attended") }}
        </template>
        <template v-if="searchType == 1 && events.length > 0">
          {{ $t("tabBar.upcoming_events") }}
        </template>
        <template v-if="searchType == 2 && events.length > 0">
          {{ $t("tabBar.past_events") }}
        </template>
      </div>
      <div class="event-block-container">
        <EventBlock :data="events" :skeleton="skeleton" />
      </div>
      <div class="event-block-footer">
        <el-button size="mini" type="primary" :loading="loading == 'loadEvents'" v-if="buttons" round @click="getActivatedEvents">{{ $t("showMore") }}</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";
import EventBlock from "@/modules/EventBlock";
export default {
  props: ["searchType", "blockCount", "close"],
  components: {
    EventBlock
  },
  data() {
    return {
      axios,
      events: [],
      skeleton: false,
      moment,
      activateModal: false,
      activationCode: "",
      activateLoading: false,
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      buttons: true,
      loading: false,
      timeout: null,
      response: {
        hasError: false,
        message: null,
        validationErrors: []
      },
      fastLogin: {
        activationCode: null,
        email: null,
        password: null,
        checkbox: false
      },
      emailRequired: false,
      passwordRequired: false,
      showpwd: false
    };
  },
  async beforeMount() {
    this.skeleton = true;
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.$route.query.activationCode != undefined && this.$route.query.activationCode != null) {
        this.activationCode = this.$route.query.activationCode;
        this.$store.dispatch("activateEvent", { activationCode: this.activationCode });
      }
      await this.getActivatedEvents();
    }, 500);
  },
  methods: {
    activateCode() {
      this.$store.state.user != null ? this.activateEvent() : this.sendFastLogin();
    },
    async sendFastLogin() {
      this.$store.commit("setEventLoading", "activation");
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.activationCode == null || this.activationCode == "") {
          this.$message.error(this.$t("fill_blank_input"));
          this.$store.commit("setEventLoading", false);
          return;
        } else {
          var res = await axios.post("login/fastlogin", {
            activationCode: this.activationCode,
            emailAddress: this.fastLogin.emailAddress,
            password: this.fastLogin.password
          });

          this.response.validationErrors = res.data.validationErrors;
          if (res.data.hasError || res.data.validationErrors.length > 0) {
            if (res.data.validationErrors.some(x => x.key == "email")) {
              this.passwordRequired = res.data.data.passwordRequired;
              this.emailRequired = res.data.data.emailRequired;
              this.$message.error(this.$t("emailRequiredFastLogin"));
              this.$store.commit("setEventLoading", false);
              return;
            } else if (res.data.validationErrors.some(x => x.key == "password")) {
              this.emailRequired = res.data.data.emailRequired;
              this.passwordRequired = res.data.data.passwordRequired;
              this.fastLogin.email = res.data.data.email;
              this.$message.error(this.$t("passwordRequiredFastLogin"));
              this.$store.commit("setEventLoading", false);
              return;
            } else {
              this.$store.commit("setEventLoading", false);
              this.$message.error(res.data.message);
              return;
            }
          } else {
            this.$store.commit("setToken", res.data.data.token);
            var eventid = res.data.data.eventId;

            var userResponse = await axios.post("account/get");
            this.$store.commit("setUser", userResponse.data.data.user);
            this.$store.commit("setNotify", userResponse.data.data);
            localStorage.setItem("token", res.data.data.token);

            await this.$store.dispatch("getEventBySlug", {
              id: eventid,
              slug: res.data.data.slug,
              route: true
            });
          }
        }
        this.$store.commit("setEventLoading", false);
      }, 500);
    },
    async activateEvent() {
      console.log("asdasd3");

      this.$store.commit("setEventLoading", "activation");

      this.timeout = setTimeout(async () => {
        if (this.timeout != null) clearTimeout(this.timeout);
        if (this.activationCode == null || this.activationCode == "") {
          this.$message.error(this.$t("fill_blank_input"));
          this.$store.commit("setEventLoading", false);
          return;
        }
        await this.$store.dispatch("activateEvent", { activationCode: this.activationCode });
      }, 500);
    },
    async getActivatedEvents() {
      this.loading = "loadEvents";
      if (this.timeout != null) clearTimeout(this.timeout);

      this.timeout = setTimeout(async () => {
        var res = await axios.post("/Explore/SearchEvent", { skip: this.events.length, take: 6, searchType: this.searchType, searchTerm: this.searchTerm });
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          var items = res.data.data.items;
          if (items.length == 0) {
            this.buttons = false;
          } else if (items.length < 6) {
            this.buttons = false;
          }
          this.events.push(...items);
        }
        this.loading = false;
        this.skeleton = false;
      }, 500);
    }
  },
  computed: {
    getResponse() {
      return this.$store.getters.getResponse;
    },
    getLoading() {
      return this.$store.getters.getLoading;
    }
  }
};
</script>

<style lang="less">
.event-block-wrapper {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 1rem;
  @media screen and (max-width: 991px) {
  }
  .activation-block {
    display: block;
    width: 100%;
    position: relative;
    max-width: 1120px;
    margin: 20px auto 30px;

    h4,
    h5 {
      margin: 0;
    }

    .info-card {
      justify-content: space-around;
      flex-direction: row;
      align-items: center;
      display: flex;
      padding: 16px 14px;
      border-radius: 8px;
      background: #ffffff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 16px;
      @media screen and (max-width: 991px) {
        flex-direction: column;
        gap: 1rem;
      }
      .custom-input {
        min-width: 300px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-top: 12px;
        font-family: "Roboto", sans-serif;

        label {
          font-family: "Roboto", sans-serif;
          color: #505763;
          font-weight: 500;
          font-size: 14px;
          margin-bottom: 6px;
        }

        &.email {
          input {
            text-transform: lowercase;
          }
        }

        &.password {
          position: relative;

          input {
            padding: 8px 42px 8px 42px !important;
          }

          .show-pwd {
            font-size: 22px;
            color: #c4c9d2;
            position: absolute;
            right: 8px;
            left: unset;
            top: 11px;
            cursor: pointer;
          }
        }

        &.disabled {
          input {
            cursor: no-drop;
            background-color: #c4c9d2;
          }

          i {
            color: #8c929c !important;
          }
        }

        &.icon {
          position: relative;

          input {
            padding: 8px 12px 8px 42px;
          }

          i {
            font-size: 22px;
            color: #c4c9d2;
            position: absolute;
            left: 10px;
            top: 10px;
          }
        }

        &.md-invalid {
          input {
            border-color: #f22f2f;
          }
        }

        input {
          width: 100%;
          border: 0;
          height: 40px;
          border-radius: 8px;
          outline: none;
          padding: 8px 12px;
          box-sizing: border-box;
          border: 0.5px solid #d6d9d9;
          background: #fbfbfb;
          height: 48px;
          font-family: "Roboto", sans-serif;
        }

        textarea {
          width: 100% !important;
          border: 0;
          height: 100px !important;
          border-radius: 8px;
          outline: none;
          padding: 8px 12px;
          box-sizing: border-box;
          border: 0.5px solid #d6d9d9;
          background: #fbfbfb;
          font-family: "Roboto", sans-serif;
          font-size: 13px;
        }

        span {
          font-size: 13px;
          color: #f22f2f;
          margin-top: 3px;
          font-family: "Roboto", sans-serif;
        }

        &.phone {
          .vue-phone-number-input {
            width: 100%;
          }

          .country-selector__country-flag {
            top: 18px;
          }

          .country-selector__input {
            border-radius: 4px 0px 0px 4px !important;
            border: 0.5px solid #d6d9d9 !important;
            box-shadow: none !important;
            padding-left: 40px;
          }

          .input-tel__input {
            border-radius: 0px 4px 4px 0px !important;
            border: 0.5px solid #d6d9d9 !important;
            box-shadow: none !important;
          }

          .country-selector__label {
            display: none;
          }

          .input-tel__label {
            display: none;
          }
        }
      }
      .info-left {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 991px) {
          flex-direction: column;
          gap: 1rem;
        }
        .info-icon {
          width: 60px;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: white;
          border: 5px solid #d6d9d9;
          border-radius: 50%;

          i {
            font-size: 26px;
            color: #268ea6;
          }
        }

        .info-header-text {
          width: calc(~"100% - 100px");
          padding-left: 20px;
          @media screen and (max-width: 991px) {
            padding-left: 0;
            width: 100%;
            text-align: center;
          }
          .info-info {
            margin: 0px;
            margin-top: 4px;

            span {
              color: #505763;
              font-size: 14px;
            }
          }
        }

        .info-title {
          line-height: 25px;

          p {
            text-overflow: ellipsis;
            max-width: 100% !important;
            white-space: nowrap;
            overflow: hidden;
            margin: 0px;
            display: block;
            color: #292f3b;
            font-weight: 600;
            font-size: 18px;
          }
        }
      }

      .info-right {
        .activation-bar {
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 100%;
          position: relative;
          min-width: 300px;
          margin: 0 auto;

          input {
            width: 100%;
            border-radius: 8px;
            outline: none;
            padding: 8px 12px;
            box-sizing: border-box;
            border: 0.5px solid #d6d9d9;
            background: #ffffff;
            height: 54px;
            font-size: 18px;
            font-weight: 700;
            font-family: "Roboto";
            color: #292f3b;
            @media screen and (max-width: 768px) {
              height: 48px;
            }
          }

          button {
            position: absolute;
            box-shadow: unset;
            border-radius: 8px;
            height: 100%;
            margin: 0px;
            right: 0px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            padding: 0px 12px;
            font-weight: 500;
            letter-spacing: 0.2px;
            font-size: 16px;
          }
        }
      }
    }
  }
  .event-block-title {
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
  }
  .event-block-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1rem;
    @media screen and (max-width: 991px) {
      grid-template-columns: 1fr;
    }
  }
  .event-block-footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/EventBlockWrapper.vue